import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import Layout from "../Common/Layout";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OrderProcess = () => {
  const token = sessionStorage.getItem("token");
  const { id } = useParams();
  const [clientList, setClientList] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);

  const RequiredStar = () => (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  );

  const [varieties, setVarieties] = useState([]);
  const [products, setProducts] = useState([]);

  const [phoneError, setPhoneError] = useState("");

  const [warehouses, setWarehouses] = useState([]); // ✅ NEW
  const [cargoTypes, setCargoTypes] = useState([]); // ✅ NEW

  useEffect(() => {
    fetchVarieties();
    fetchWarehouses(); // ✅ Fetch warehouses on load
    fetchCargoTypes(); // ✅ NEW
    fetchProducts(); // ✅ ADD THIS
  }, []);
   
  useEffect(() => {
  if (id) {
    fetchMasterClient();
  }
}, [id]);

  useEffect(() => {
    const closeDropdown = (e) => {
      if (!e.target.closest("#companyName")) {
        setShowClientDropdown(false);
      }
    };

    document.addEventListener("click", closeDropdown);

    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  const fetchCargoTypes = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/cargo-types/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setCargoTypes(res.data);
    } catch (err) {
      console.error("Failed to load cargo types", err);
    }
  };

  const fetchProducts = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/products/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setProducts(res.data);
    } catch (err) {
      console.error("Failed to load products", err);
    }
  };

  // Fetch varieties
  const fetchVarieties = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(
        "https://irc.zentelex.com/api/varieties/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setVarieties(res.data);
    } catch (err) {
      console.error("Failed to load varieties", err);
    }
  };

  // Fetch warehouses
  // const fetchWarehouses = async () => {
  //   try {
  //     const res = await axios.get(
  //       "https://irc.zentelex.com/api/warehouses/dropdown",
  //     );
  //     setWarehouses(res.data);
  //   } catch (err) {
  //     console.error("Failed to load warehouses", err);
  //   }
  // };

  const fetchWarehouses = async () => {
    try {
      // 1️⃣ Get warehouse from API
      const res = await axios.get(
        "https://irc.zentelex.com/api/warehouses/dropdown",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const apiWarehouses = res.data || [];

      // 2️⃣ Get warehouse from sessionStorage
      const storedWarehouse = sessionStorage.getItem("warehouse_location");

      let finalWarehouses = apiWarehouses;

      // 3️⃣ Compare API warehouse with sessionStorage value
      if (storedWarehouse) {
        const matched = apiWarehouses.find((w) => w.name === storedWarehouse);

        if (matched) {
          // ✅ If match found → show only that warehouse
          finalWarehouses = [matched];
        } else {
          // ✅ If not found → add sessionStorage warehouse manually
          finalWarehouses = [
            ...apiWarehouses,
            {
              id: "local-1",
              name: storedWarehouse,
              address: storedWarehouse,
              labourContractor: "",
            },
          ];
        }
      }

      setWarehouses(finalWarehouses);
    } catch (err) {
      console.error("Failed to load warehouses", err);
    }
  };

  const warehouseAddressMap = {};
  warehouses.forEach((w) => {
    warehouseAddressMap[w.name] = w.address;
  });

  const navigate = useNavigate();

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const [formData, setFormData] = useState({
    companyName: "",
    contactNo: "",
    address: "",

    product: "", // ✅ now dropdown
    customProduct: "", // ✅ NEW
    variety: "", // ✅ NEW
    warehouse: "", // ✅ NEW
    warehouseAddress: "", // ✅ ADD
    labourContractorName: "", // ✅ NEW

    blVesselNo: "", // ✅ NEW
    quantity: "",
    cargoType: "",
    customCargoType: "", // ✅ NEW
    quality: "",
    remarks: "", // ✅ NEW
    date: getTodayDate(), // 👈 auto current date
  });

  const fetchClients = async (searchText = "") => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/master-client/search?query=${searchText}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const uniqueClients = Array.from(
        new Map(res.data.map((item) => [item.company_name, item])).values(),
      );

      setClientList(uniqueClients);
      setShowClientDropdown(true);
    } catch (err) {
      console.error("Client search failed", err);
    }
  };

  // Handle input changes
  const handleChange = async (e) => {
    const { id, value } = e.target;

    // ✅ Allow only numbers in contactNo
    if (id === "contactNo") {
      const numericValue = value.replace(/\D/g, ""); // remove non-digits

      if (numericValue.length > 10) return; // stop more than 10 digits

      setFormData((prev) => ({
        ...prev,
        contactNo: numericValue,
      }));

      // ✅ Validation message
      if (numericValue.length > 0 && numericValue.length < 10) {
        setPhoneError("Phone number must be 10 digits");
      } else {
        setPhoneError("");
      }

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));

    // ✅ SEARCH CLIENTS WHEN TYPING COMPANY NAME
    if (id === "companyName") {
      fetchClients(value);
    }

    // 🔹 Existing warehouse logic (keep your code)
    if (id === "warehouse") {
      const selectedWarehouse = warehouses.find((w) => w.name === value);

      setFormData((prev) => ({
        ...prev,
        warehouse: value,
        warehouseAddress:
          value === "OTHER" ? "" : selectedWarehouse?.address || "",
        labourContractorName:
          value === "OTHER" ? "" : selectedWarehouse?.labourContractor || "",
      }));
    }
  };


 const fetchMasterClient = async () => {
  try {
    const res = await axios.get(
      `https://irc.zentelex.com/api/master-client/getclients/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const d = res.data.data;

    setFormData((prev) => ({
      ...prev,
      companyName: d.company_name || "",
      contactNo: d.contact_number || "",
      address: d.address || "",

      product: d.product || "",
      variety: d.variety || "",
      warehouse: d.warehouse || "",
      warehouseAddress: d.warehouse_address || "",
      labourContractorName: d.labourContractor || "",

      blVesselNo: d.bl_vessel_no || "",
      quantity: d.quantity || "",
      cargoType: d.cargo_type || "",
      quality: d.quality_grade || "",
      remarks: d.remarks || "",
      date: d.order_date || "",
    }));
  } catch (err) {
    console.error(err);
    toast.error("Unable to load Master Client");
  }
};


  const handleSelectClient = (client) => {
    setFormData((prev) => ({
      ...prev,
      companyName: client.company_name,
      address: client.address,
      contactNo: client.contact_number,
    }));

    setShowClientDropdown(false);
  };

  // Handle form submission

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.contactNo && formData.contactNo.length !== 10) {
      toast.error("Contact number must be 10 digits", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }

    const token = sessionStorage.getItem("token");

    let finalProduct = formData.product;

    // ✅ Add product if "Other"
    if (formData.product === "OTHER" && formData.customProduct) {
      const addProductRes = await axios.post(
        "https://irc.zentelex.com/api/products",
        { name: formData.customProduct },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      finalProduct = addProductRes.data.name;

      // Update dropdown instantly
      setProducts((prev) => [...prev, addProductRes.data]);
    }

    let finalCargoType = formData.cargoType;

    // ✅ Add cargo type if "Other"
    if (formData.cargoType === "OTHER" && formData.customCargoType) {
      const addCargoTypeRes = await axios.post(
        "https://irc.zentelex.com/api/cargo-types",
        { name: formData.customCargoType },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      finalCargoType = addCargoTypeRes.data.cargoType.name;

      // Update dropdown instantly
      setCargoTypes((prev) => [...prev, addCargoTypeRes.data.cargoType]);
    }

    // 🔔 Beautiful confirmation popup
    const result = await Swal.fire({
      title: "Confirm Submission",
      text: "Are you sure you want to submit this Order for Approval?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745", // green
      cancelButtonColor: "#d33", // red
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    // ❌ If user cancels
    if (!result.isConfirmed) {
      return;
    }

    try {
      let finalVariety = formData.variety;
      let finalWarehouse =
        formData.warehouse === "OTHER"
          ? formData.customWarehouse
          : formData.warehouse;

      // ✅ Add variety if "Other"
      if (formData.variety === "OTHER" && formData.customVariety) {
        const addVarietyRes = await axios.post(
          "https://irc.zentelex.com/api/varieties",
          { name: formData.customVariety },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        finalVariety = addVarietyRes.data.name;

        // Update dropdown list
        setVarieties((prev) => [...prev, addVarietyRes.data]);
      }

      // ✅ Add warehouse if "Other"
      if (formData.warehouse === "OTHER" && formData.customWarehouse) {
        const addWarehouseRes = await axios.post(
          "https://irc.zentelex.com/api/warehouses",
          {
            name: formData.customWarehouse,
            address: formData.warehouseAddress,
            labourContractor: formData.labourContractorName, // 🔥 ADD THIS LINE
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        finalWarehouse = addWarehouseRes.data.name;

        // Update dropdown list immediately
        setWarehouses((prev) => [...prev, addWarehouseRes.data]);

        // Auto-select newly added warehouse
        setFormData((prev) => ({
          ...prev,
          warehouse: addWarehouseRes.data.name,
          warehouseAddress: addWarehouseRes.data.address,
          labourContractorName: addWarehouseRes.data.labourContractor, // 🔥 ADD
        }));
      }

      // ✅ Prepare order payload
      const payload = {
        company_name: formData.companyName,
        contact_number: formData.contactNo || null,
        address: formData.address,
        product: finalProduct,
        cargo_type: finalCargoType,
        variety: finalVariety,
        warehouse: finalWarehouse,
        warehouse_address: formData.warehouseAddress,
        labourContractor: formData.labourContractorName, // 🔥 ADD THIS

        bl_vessel_no: formData.blVesselNo,
        quantity: formData.quantity,
        quality_grade: formData.quality,
        remarks: formData.remarks,
        order_date: formData.date,
      };

      const response = await axios.post(
        "https://irc.zentelex.com/api/master-client",
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data.success) {
        toast.success("✅ Data submitted for Approval!", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });

        sessionStorage.setItem(
          "orderprocess",
          JSON.stringify(response.data.data),
        );

        navigate("/gateway-entry");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  return (
    <>
      <ToastContainer />

      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right"></div>
                    <h4 className="page-title">Welcome!</h4>
                  </div>
                </div>
              </div>

              {/* ===================== FORM START ===================== */}
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div
                      className="card-body rounded-4 p-4"
                      style={{ backgroundColor: "#3075A6", color: "white" }}
                    >
                      <h4
                        className="card-title mb-4 text-center fw-semibold"
                        style={{ color: "white" }}
                      >
                        Order Processing
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* Company Name */}
                        <div className="mb-3 position-relative">
                          <label
                            htmlFor="companyName"
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Company Name <RequiredStar />
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            placeholder="Enter company name"
                            value={formData.companyName}
                            onChange={handleChange}
                            onFocus={() => fetchClients("")} // ⭐ LOAD ALL CLIENTS
                            autoComplete="off"
                          />

                          {/* ✅ CLIENT DROPDOWN */}
                          {showClientDropdown && clientList.length > 0 && (
                            <ul
                              className="list-group"
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                width: "100%",
                                maxHeight: "220px",
                                overflowY: "auto",
                                zIndex: 1050,

                                background: "#fff",
                                borderRadius: "8px",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.15)",

                                /* MOBILE FIX */
                                maxWidth: "100%",
                              }}
                            >
                              {clientList.map((client) => (
                                <li
                                  key={client.id}
                                  className="list-group-item list-group-item-action"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSelectClient(client)}
                                >
                                  <strong>{client.company_name}</strong>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        {/* Contact Number */}
                        <div className="mb-3">
                          <label
                            htmlFor="contactNo"
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Contact Number
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="contactNo"
                            placeholder="Enter contact number"
                            value={formData.contactNo}
                            onChange={handleChange}
                            maxLength="10"
                            title="Please enter a valid 10-digit mobile number"
                          />
                          {phoneError && (
                            <small
                              style={{ color: "yellow", fontWeight: "bold" }}
                            >
                              {phoneError}
                            </small>
                          )}
                        </div>

                        {/* Address */}
                        <div className="mb-3">
                          <label
                            htmlFor="address"
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Address
                            <RequiredStar />
                          </label>
                          <textarea
                            className="form-control"
                            id="address"
                            placeholder="Enter full address"
                            rows="2"
                            value={formData.address}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Product & Quantity */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Product / Commodity
                              <RequiredStar />
                            </label>

                            <select
                              className="form-select"
                              id="product"
                              value={formData.product}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Product</option>

                              {products.map((p) => (
                                <option key={p.id} value={p.name}>
                                  {p.name}
                                </option>
                              ))}

                              <option value="OTHER">Other (Custom)</option>
                            </select>

                            {/* 👇 Show input when OTHER selected */}
                            {formData.product === "OTHER" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                id="customProduct"
                                placeholder="Enter custom product"
                                value={formData.customProduct || ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    customProduct: e.target.value,
                                  })
                                }
                                required
                              />
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Cargo Type <RequiredStar />
                            </label>

                            <select
                              className="form-select"
                              id="cargoType"
                              value={formData.cargoType}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Cargo Type</option>

                              {cargoTypes.map((c) => (
                                <option key={c.id} value={c.name}>
                                  {c.name}
                                </option>
                              ))}

                              <option value="OTHER">Other (Custom)</option>
                            </select>

                            {/* 👇 Show input when OTHER selected */}
                            {formData.cargoType === "OTHER" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                id="customCargoType"
                                placeholder="Enter custom cargo type"
                                value={formData.customCargoType || ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    customCargoType: e.target.value,
                                  })
                                }
                                required
                              />
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Variety
                              <RequiredStar />
                            </label>

                            <select
                              className="form-select"
                              id="variety"
                              name="variety" // VERY IMPORTANT
                              value={formData.variety}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Variety</option>

                              {varieties.map((v) => (
                                <option key={v.id} value={v.name}>
                                  {v.name}
                                </option>
                              ))}

                              <option value="OTHER">Other (Custom)</option>
                            </select>

                            {/* 👇 Show input only when "Other" is selected */}
                            {formData.variety === "OTHER" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                id="customVariety"
                                placeholder="Enter custom variety"
                                value={formData.customVariety || ""}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    customVariety: e.target.value,
                                  })
                                }
                                required
                              />
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Warehouse
                              <RequiredStar />
                            </label>

                            <select
                              className="form-select"
                              id="warehouse"
                              value={formData.warehouse}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Warehouse</option>
                              {warehouses.map((w) => (
                                <option key={w.id} value={w.name}>
                                  {w.name}
                                </option>
                              ))}
                              <option value="OTHER">Other (Custom)</option>
                            </select>

                            {formData.warehouse === "OTHER" && (
                              <input
                                type="text"
                                className="form-control mt-2"
                                id="customWarehouse"
                                placeholder="Enter custom warehouse"
                                value={formData.customWarehouse || ""}
                                onChange={handleChange}
                                required
                              />
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-semibold">
                              Labour Contractor Name
                              <RequiredStar />
                            </label>
                            <input
                              type="text"
                              id="labourContractorName"
                              value={formData.labourContractorName}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter / edit labour contractor name"
                              required
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Warehouse Address
                              <RequiredStar />
                            </label>

                            <textarea
                              className="form-control"
                              id="warehouseAddress"
                              value={formData.warehouseAddress}
                              onChange={handleChange}
                              rows={3}
                              placeholder={
                                formData.warehouse === "OTHER"
                                  ? "Enter custom warehouse address"
                                  : "Warehouse address will auto-fill"
                              }
                              readOnly={formData.warehouse !== "OTHER"} // 🔥 KEY LINE
                              required
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              BL NO / Vessel Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="blVesselNo"
                              placeholder="BL NO / Vessel Name"
                              value={formData.blVesselNo}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="mb-4">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Remarks
                            </label>
                            <textarea
                              className="form-control"
                              id="remarks"
                              rows="2"
                              placeholder="Additional remarks (optional)"
                              value={formData.remarks}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* Quality & Dates */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="quality"
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Quality Grade
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="quality"
                              placeholder="e.g., A+, B, etc."
                              value={formData.quality}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="date"
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Date
                              <RequiredStar />
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="date"
                              value={formData.date}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Tentative Storage Date */}

                        {/* Submit Button */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn px-5 py-2 fw-semibold"
                            style={{
                              backgroundColor: "#EC662C",
                              color: "white",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ===================== FORM END ===================== */}
            </div>
          </div>
        </div>

        {/* ✅ Toast container must be rendered once */}
      </Layout>
    </>
  );
};

export default OrderProcess;
